<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{$t("setting.add_bank")}}</span>
      </div>
      <div class="bank" v-else>
          <div class="info">
            <div class="row-item">
              <div class="row-label">{{bankFieldLabels.bank}}</div>
              <div class="row-content">{{this.bankInfo.bankinfo || '-'}}</div>
            </div>
            <div class="row-item">
              <div class="row-label">{{bankFieldLabels.branchName}}</div>
              <div class="row-content">{{this.bankInfo.branch_name || '-'}}</div>
            </div>
            <div class="row-item">
              <div class="row-label">{{bankFieldLabels.branchNo}}</div>
              <div class="row-content">{{this.bankInfo.branch_no || '-'}}</div>
            </div>
            <div class="row-item">
              <div class="row-label">{{bankFieldLabels.accountNo}}</div>
              <div class="row-content">{{this.bankInfo.bankid || '-'}}</div>
            </div>
            <div class="row-item">
              <div class="row-label">{{bankFieldLabels.accountName}}</div>
              <div class="row-content">{{this.bankInfo.username || '-'}}</div>
            </div>
          </div>
      </div>
      <div class="tips">{{$t("setting.bind_bank_tip")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      bankFieldLabels: {
        bank: '銀行名',
        branchName: '支店名',
        branchNo: '支店番号',
        accountNo: '口座番号',
        accountName: '口座名義'
      }
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      this.$router.push({path:'/BindCard'})
      // if (!this.userInfo.name) {
      //   this.$router.push("Setname");
      //   this.$toast(this.$t("setting.set_name_bank"));
      //   return true;
      // }else if(!this.userInfo.paypassword){
      //   this.$router.push("SetPayPassword");
      //   this.$toast(this.$t("setting.set_pwd_bank"));
      //   return true;
      // } else {
      //   this.$router.push({path:'/BindCard'})
      // }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.manage-card .wrapper{
  height: calc(100% - 10px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.wrapper .add-card{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  background-color: #fff;
  height: 250px;
}
.wrapper .add-card span{
  margin-left: 10px;
  font-size: 30px;
}
.wrapper .tips {
  margin: 15px 15px;
  font-size: 25px;
  color: #979799;
}
.wrapper .bank .info {
  padding: 20px;
  flex: 1;
  color: #000;
}
.wrapper .bank .info .row-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 0;
  border-bottom: 1px solid #f2f2f5;
}
.wrapper .bank .info .row-item:last-child{
  border-bottom: none;
}
.wrapper .bank .info .row-label{
  width: 180px;
  font-size: 28px;
  color: #666;
}
.wrapper .bank .info .row-content{
  flex: 1;
  line-height: 1.4;
  font-size: 30px;
  text-align: right;
  word-break: break-all;
}
</style>
